const components = {
  apps: {
    shop: ['mundipagg', 'pagarme'],
    hub: ['mundipagg', 'pagarme']
  },
  logo: {
    mundipagg: [],
    pagarme: ['mundipagg', 'pagarme']
  },
  filter: {
    tagInfo: ['mundipagg', 'pagarme']
  },
  recipients: {
    linkMundipagg: ['mundipagg'],
    linkPagarme: ['pagarme'],
    balance: ['pagarme', 'mundipagg'],
    transfers: ['pagarme'],
    settlements: ['pagarme', 'mundipagg']
  },
  sidemenu: {
    balance: ['pagarme', 'mundipagg'],
    transfers: ['pagarme'],
    home: ['mundipagg', 'pagarme'],
    trf: ['mundipagg'],
    plans: ['mundipagg', 'pagarme'],
    subscriptions: ['mundipagg', 'pagarme'],
    invoices: ['mundipagg', 'pagarme'],
    recipients: ['mundipagg', 'pagarme'],
    settings: ['mundipagg', 'pagarme'],
    webhookConfig: ['mundipagg', 'pagarme']
  },
  charge: {
    attempt: ['mundipagg', 'pagarme'],
    capture: ['mundipagg', 'pagarme'],
    cancel: ['mundipagg', 'pagarme'],
    confirm: ['mundipagg', 'pagarme']
  },
  subscription: {
    cancel: ['mundipagg', 'pagarme']
  },
  roles: {
    shop: ['mundipagg', 'pagarme'],
    psp: ['pagarme', 'mundipagg']
  },
  global: {
    onboarding: ['mundipagg', 'pagarme'],
    nps: ['mundipagg', 'pagarme'],
    pix: ['mundipagg', 'pagarme'],
    modalHeader: ['mundipagg']
  },
  globalError: {
    logo: ['mundipagg', 'pagarme']
  },
  onboarding: {
    feedback: ['mundipagg', 'pagarme'],
    settings: ['mundipagg', 'pagarme']
  },
  footer: {
    textPagarme: ['pagarme'],
    textMundipagg: ['mundipagg'],
    switchThemeMode: ['mundipagg'],
    status: ['mundipagg', 'pagarme'],
    help: ['mundipagg', 'pagarme'],
    documentation: ['mundipagg', 'pagarme'],
    urlSite: ['mundipagg', 'pagarme'],
    switchLanguage: ['mundipagg'],
    privacyPolicy: ['mundipagg', 'pagarme'],
    termsOfUse: ['mundipagg', 'pagarme'],
    termsOfUseModal: [],
    secureEnv: ['mundipagg', 'pagarme']
  }
}

export default components
